import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_INTEGRATION_SATELLITE_IMAGERY',
  name: 'Workspace Project Satellite Image Integration',
  type: 'PROJECT',
  description: '',
  modules: [],
  actions: ['READ', 'CREATE', 'UPLOAD', 'DESTROY'],
}

export default scope
